import { OrderLocatorTab } from 'state/launchdarkly/variations';
import { TLocalizationKey } from 'types/i18n';

export enum EmptyStateCategories {
  NO_AUTH = 'noAuth',
  NO_LOCATION = 'noLocation',
  NO_STORES = 'noStores',
  ERROR = 'error',
  TEST = 'test',
}

export enum EmptyStateActions {
  LOGIN = 'login',
  SHARE_LOCATION = 'shareLocation',
}

export interface IEmptyStateContent {
  icon?: () => JSX.Element;
  titleId: TLocalizationKey;
  bodyId: TLocalizationKey;
  action?: EmptyStateActions;
}

interface IEmptyStateCategoryOptions {
  [key: string]: IEmptyStateContent;
}

export interface IEmptyStateTabOptions {
  [key: string]: IEmptyStateCategoryOptions;
}

export interface IStoreLocatorEmptyStatesProps {
  tab: OrderLocatorTab;
  locationPermissionsGranted: boolean;
  currentTabError: boolean;
  coordinatesAvailable?: boolean;
}
